import React, { Component } from 'react'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

class Subjects extends Component {
  render() {
    const { subjects } = this.props
    let total = 0

    return (
      <div className="cor-subjects">
        <form className="grid-form">
          <Fieldset legend="Enrolled Subjects">
            <table className="table table-condensed">
              <thead>
                <tr>
                  <th width="12%">Code</th>
                  <th width="12%">Section</th>
                  <th>Description</th>
                  <th width="15%">Schedule</th>
                  <th width="20%">Instructor</th>
                  <th width="4%" className="text-right">Lec</th>
                  <th width="4%" className="text-right">Lab</th>
                  <th width="4%" className="text-right">Units</th>
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject, k) => {
                  total += subject.get('units') - 0

                  return (
                    <tr key={k}>
                      <td><small>{subject.get('subject_code')}</small></td>
                      <td><small>{subject.get('section')}</small></td>
                      <td><small>{subject.get('subject_name')}</small></td>
                      <td>{''}</td>
                      <td>
                        <small><em>{subject.get('instructor_name')}</em></small>
                      </td>
                      <td className="text-right">
                        {acc.formatNumber(subject.get('lec_units'), 1)}
                      </td>
                      <td className="text-right">
                        {acc.formatNumber(subject.get('lab_units'), 1)}
                      </td>
                      <td className="text-right">
                        <strong>{acc.formatNumber(subject.get('units'), 1)}</strong>
                      </td>
                    </tr>
                  )
                })}
                <tr>
                  <td className="text-center" colSpan="4">
                    <small><em>*** NOTHING FOLLOWS ***</em></small>
                  </td>
                  <th className="text-right" colSpan="3">Total Units:</th>
                  <th className="text-right">{acc.formatNumber(total, 1)}</th>
                </tr>
              </tbody>
            </table>
          </Fieldset>
        </form>
      </div>
    )
  }
}

export default Subjects



// WEBPACK FOOTER //
// ./src/containers/COR2/subjects.js